import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { SecondaryText } from 'Components/Texts';
import { WatchNowButton } from 'Components/WatchNowButton';
import { Navigate } from 'react-router-dom';
import { logger } from 'Utils/Logger';
import { fetchSubscriptionStatus, fetchSubscriptions } from 'State/Subscriptions/SubscriptionsActions';
import { useStore } from 'Hooks/useStore';

export const CancelConfirmationContainer = () => {
  const dispatch = useDispatch();
  const [validityTillFormatted, setValidityTillFormatted] = useState();
  const { email } = useStore('user');
  const { nextBillInfo } = useSelector((s) => s.payments);
  const { routes } = useStore('appConfig');
  const subscription = useSelector((s) => s.subscription);

  useEffect(() => {
    dispatch(fetchSubscriptions());
    dispatch(fetchSubscriptionStatus());
  }, [dispatch]);

  useEffect(() => {
    if (nextBillInfo && nextBillInfo.nextBillingDateTime) {
      const tillDate =
        subscription.isTrialistUser === true ? subscription.validityTill : nextBillInfo.nextBillingDateTime;
      logger.started('cancel confirm date', nextBillInfo);
      let validityTill = new Date(tillDate);
      // add extra day to cancel date: https://fng-jira.fox.com/browse/DCGC-2404
      validityTill = validityTill.setDate(validityTill.getDate() + 1);
      const validityTillFormatted = new Date(validityTill).toLocaleDateString('en-US');
      logger.completed('cancel confirm date', { validityTillFormatted });
      setValidityTillFormatted(validityTillFormatted);
    }
  }, [nextBillInfo, subscription]);

  const confirmFirstMessage = (
    <Fragment>
      An email confirmation will be sent to{' '}
      <span key="a" className="cancelConfirmEmail" data-dd-privacy="mask" data-heap-redact-text>{` ${email}`}</span>
    </Fragment>
  );

  const confirmSecondMessage = (
    <Fragment>
      Your Fox Nation subscription has been canceled, effective{' '}
      <span key="b" className="validUntilDate">
        {validityTillFormatted}.
      </span>{' '}
      Until then, you can continue to enjoy exclusive daily shows.
    </Fragment>
  );

  if (!nextBillInfo) {
    return <Navigate to={routes.myAccount} replace />;
  }

  return (
    <CenterFrameLayout title="Your plan has been canceled" showLoader={false}>
      <div className="centerFormWide">
        <div className="cancelContainer">
          <SecondaryText alignText="centerText" text={confirmFirstMessage} className="emailConfirmMsg" />
          <SecondaryText alignText="centerText" text={confirmSecondMessage} className="cancelPlanMsg" />
          <WatchNowButton buttonText="Continue Watching Now" />
        </div>
      </div>
    </CenterFrameLayout>
  );
};
